import type { PaymentCancelStatus, PaymentStatus } from '@repo/api-contracts';
import type { StatusTone } from '@/shared/ui';

/**
 * 결제 상태 배지 톤 — 결제 목록(widgets/payments-table)과 같은 기준. neutral 고객 결제 대기 / positive 결제 완료 /
 * warning 일부만 환불된 건 / danger 더 진행되지 않는 건(전액 환불·승인 실패·만료).
 */
export const PAYMENT_STATUS_TONES: Readonly<Record<PaymentStatus, StatusTone>> = {
  READY: 'neutral',
  DONE: 'positive',
  PARTIAL_CANCELED: 'warning',
  CANCELED: 'danger',
  ABORTED: 'danger',
  EXPIRED: 'danger',
};

/** 환불 한 건의 상태 톤 — attention 처리 중(다시 시도할 건) / positive 환불 완료 / danger 환불 실패. */
export const PAYMENT_CANCEL_STATUS_TONES: Readonly<Record<PaymentCancelStatus, StatusTone>> = {
  PENDING: 'attention',
  DONE: 'positive',
  FAILED: 'danger',
};
